import {Component, OnInit, ViewChild} from '@angular/core';
import {Category} from '../../../Models/category';
import {CategoryService} from '../../../Services/category.service';
import {WissalstoreService} from '../../../Services/wissalstore.service';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';

@Component({
    selector: 'app-category-filter',
    templateUrl: './category-filter.component.html',
    styleUrls: ['./category-filter.component.scss'],
    standalone: false
})
export class CategoryFilterComponent implements OnInit {
  categoryExpanded = false;
  categories?: Category[];
  selectedCategoryId?: number ;
  selected?: number;
  constructor(private route: ActivatedRoute, private categoryService: CategoryService, private router: Router,
              private wissalStoreService: WissalstoreService) {
  }

  ngOnInit() {
    // this.selectedCategoryId = this.wissalStoreService.selectedCategoryId;
    this.categoryService.categories.subscribe((categories: Category[]) => this.categories = categories);
    // this.selectedCategoryId = Number(this.getActivatedRoute().snapshot.paramMap.get('id'));
    this.route.paramMap.subscribe((params: ParamMap) => this.selectedCategoryId = Number(params.get('id')));
  }

  get parentCategories(): Category[] {
    return this.categories!.filter(category => category.parentId === null && category.id === this.selectedCategoryId)
      .concat(this.categories!.filter((category => category.parentId === null && category.id !== this.selectedCategoryId)));
  }

  selectCategory(category: Category) {
    // category.label = category.label.replace(/[^a-zA-Z0-9]/g, '-');
    this.router.navigate(['/products/category', category.id, category.label],{
      relativeTo: this.getActivatedRoute()
    });
  }

  getActivatedRoute(): ActivatedRoute {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  get childCategories(): Category[] {
    return this.categories!.filter((category => category.parentId === this.selectedCategoryId));
  }
}
